window.gMapsLoaded = false;
window.gMapsCallback = function () {
    window.gMapsLoaded = true;
    $(window).trigger('gMapsLoaded');
    window.gMapDef.resolve();
};
window.loadGoogleMaps = function () {
    if ( window.gMapsLoaded ) {
        window.gMapsCallback();
        return window.gMapDef.promise();
    }
    if ( !window.gMapDef ) {
        window.gMapDef = $.Deferred();
        var script_tag = document.createElement('script');
        script_tag.setAttribute("type","text/javascript");
        // Njihov: AIzaSyANZ1JkYycRKTIa5mEFaD4CQcc1YPo9YSc
        // nas : AIzaSyAg5PTZi_9KipowysEIRbZZs0YMCN-zI58
        //script_tag.setAttribute("src","https://maps.google.com/maps/api/js?key=AIzaSyAg5PTZi_9KipowysEIRbZZs0YMCN-zI58&sensor=false&callback=gMapsCallback");
        script_tag.setAttribute("src","https://maps.googleapis.com/maps/api/js?key=AIzaSyANZ1JkYycRKTIa5mEFaD4CQcc1YPo9YSc&libraries=maps,marker&callback=gMapsCallback");
        //script_tag.setAttribute("src","https://maps.google.com/maps?key=AIzaSyAg5PTZi_9KipowysEIRbZZs0YMCN-zI58&libraries=maps,marker&callback=gMapsCallback");
        script_tag.defer = true;
        (document.getElementsByTagName("head")[0] || document.documentElement).appendChild(script_tag);
    }
    return window.gMapDef.promise();
};